var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Bell = function Bell(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 18H4a1 1 0 0 1-.493-1.87A3 3 0 0 0 5 13.935V11l.001-.047A8 8 0 0 1 9.07 4.356a3 3 0 0 1 5.86 0A8.001 8.001 0 0 1 19 11v2.935a3 3 0 0 0 1.493 2.195A1 1 0 0 1 20 18h-4a4 4 0 0 1-8 0Zm3.293-13.707A1 1 0 0 1 13 5a1 1 0 0 0 .572.904A6 6 0 0 1 17 11.024V14c0 .04.002.08.007.12A5 5 0 0 0 17.63 16H6.37a5 5 0 0 0 .623-1.88A1 1 0 0 0 7 14v-2.976a6 6 0 0 1 3.409-5.111.998.998 0 0 0 .591-.929 1 1 0 0 1 .293-.691ZM14 18a2 2 0 0 1-4 0h4Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Bell;